import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  colorLandingBrandSoft,
  colorLandingBrandStrong,
  colorLandingLine,
  colorLandingMuted,
  colorLandingSurface,
  colorLandingText,
  colorLandingWhatsapp,
  colorLandingWhatsappSoft,
} from "src/design/tokens";

// Illustrative guest list for the feature showcase.
const ROWS = [
  { initials: "SB", name: "Sofia Bennani", covers: 4, time: "20:30", whatsapp: false },
  { initials: "YM", name: "Younes Mansouri", covers: 2, time: "21:00", whatsapp: true },
  { initials: "KT", name: "Karima Tazi", covers: 6, time: "19:30", whatsapp: false },
];

/** Reservation rows shown for the real-time reservations tab. */
export const BookingsMedia = () => {
  const { t } = useTranslation();

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1, width: "100%" }}>
      {ROWS.map((row) => (
        <Box
          key={row.initials}
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.25,
            backgroundColor: colorLandingSurface,
            border: `1px solid ${colorLandingLine}`,
            borderRadius: "10px",
            px: 1.375,
            py: 1,
            fontSize: 12.5,
          }}
        >
          <Box
            sx={{
              width: 26,
              height: 26,
              borderRadius: "50%",
              backgroundColor: colorLandingBrandSoft,
              color: colorLandingBrandStrong,
              display: "grid",
              placeItems: "center",
              fontWeight: 700,
              fontSize: 10,
              flexShrink: 0,
            }}
          >
            {row.initials}
          </Box>
          <Typography sx={{ fontSize: 12.5, fontWeight: 600, color: colorLandingText }}>
            {row.name}
            <Box
              component="span"
              sx={{ color: colorLandingMuted, fontWeight: 400, fontSize: 11 }}
            >
              {` · ${row.covers} ${t(
                "landingPage.ecosystem.dashboard.covers"
              ).toLowerCase()}`}
            </Box>
          </Typography>
          <Box
            sx={{
              ml: "auto",
              fontSize: 9.5,
              fontWeight: 700,
              px: 1,
              py: 0.375,
              borderRadius: 999,
              whiteSpace: "nowrap",
              ...(row.whatsapp
                ? {
                    backgroundColor: colorLandingWhatsappSoft,
                    color: colorLandingWhatsapp,
                  }
                : {
                    backgroundColor: colorLandingBrandSoft,
                    color: colorLandingBrandStrong,
                  }),
            }}
          >
            {row.whatsapp
              ? "WhatsApp"
              : t("landingPage.ecosystem.dashboard.confirmed")}
          </Box>
          <Typography sx={{ fontSize: 11, fontWeight: 700, color: colorLandingText }}>
            {row.time}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};
